import React from "react";
import {
  Box,
  Typography,
  Link,
  Grid,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { Facebook, Instagram, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {!isMobile ? (
        <Box
          component="footer"
          sx={{
            backgroundColor: "#f5f5f5",
            padding: "20px 0",
            textAlign: "center",
            borderTop: "1px solidrgb(239, 238, 238)",
          }}
        >
          <Grid container justifyContent="center" spacing={3} sx={{ mb: 2 }}>
            {[
              "About",
              "Career",
              "Privacy policy",
              "Terms and Conditions",
              "Contact us",
            ].map((item) => (
              <Grid item key={item}>
                <Link
                  href={`/#/${item.split(" ").join("_").toLowerCase()}`}
                  underline="none"
                  color="text.primary"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    textTransform: "lowercase",
                    fontFamily: "niavhFont",
                  }}
                >
                  {item}
                </Link>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            {[
              { icon: <Facebook />, href: "#" },
              { icon: <Instagram />, href: "#" },
              { icon: <LinkedIn />, href: "#" },
            ].map((social, index) => (
              <IconButton
                key={index}
                href={social.href}
                sx={{
                  color: "#757575",
                  mx: 1,
                  border: "1px solid #e0e0e0",
                  "&:hover": {
                    color: "#000",
                    backgroundColor: "#f0f0f0",
                  },
                }}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textTransform: "lowercase", fontFamily: "niavhFont" }}
          >
            © 2025 niavh. All rights reserved.
          </Typography>
        </Box>
      ) : (
        <Box
          component="footer"
          sx={{
            backgroundColor: "#f5f5f5",
            padding: "20px 0",
            borderTop: "1px solid rgb(239, 238, 238)",
            width:"100%"
          }}
        >
          <Grid
            container
            justifyContent="space-evenly"
            gap="50px"
            alignItems="center"
            sx={{ maxWidth: "900px", margin: "0 auto", padding: "0 20px" }}
          >
            {/* Left - Navigation Links */}
            <Grid item>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                {[
                  "About",
                  "Career",
                  "Privacy policy",
                  "Terms and Conditions",
                  "Contact us",
                ].map((item) => (
                  <Link
                    key={item}
                    href={`/#/${item.split(" ").join("_").toLowerCase()}`}
                    underline="none"
                    color="text.primary"
                    sx={{
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "niavhFont",
                    }}
                  >
                    {item}
                  </Link>
                ))}
              </Box>
            </Grid>

            {/* Right - Social Icons */}
            <Grid item>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                {[
                  { icon: <Facebook />, href: "#" },
                  { icon: <Instagram />, href: "#" },
                  { icon: <LinkedIn />, href: "#" },
                ].map((social, index) => (
                  <IconButton
                    key={index}
                    href={social.href}
                    sx={{
                      color: "#757575",
                      border: "1px solid #e0e0e0",
                      "&:hover": {
                        color: "#000",
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Box>
            </Grid>
          </Grid>

          {/* Footer Text */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              textAlign: "center",
              marginTop: "20px",
              fontFamily: "niavhFont",
            }}
          >
            © 2025 niavh. All rights reserved.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default Footer;
